import type { CSSObject, Theme } from "@mui/material/styles";

// Returns the theme-resolver shape directly (rather than `SxProps<Theme>`) so
// callers can both pass the result to `sx={...}` AND spread it inline via
// `containedCardSx(...)(theme)` when composing with other style fragments.
export const containedCardSx =
  (checked: boolean, hasError: boolean = false) =>
  (theme: Theme): CSSObject => {
    const rmh = theme.vars!.palette.rmh;

    const stateStyles = (() => {
      if (hasError) {
        return {
          borderColor: rmh.border["8-error"].active,
          backgroundColor: rmh.paper["9-errorFaint"].rest,
        };
      }
      if (checked) {
        return {
          borderColor: rmh.border["1-surface"].active,
          backgroundColor: rmh.paper["1-surface"].hover,
        };
      }
      return {
        borderColor: rmh.border["1-surface"].rest,
        backgroundColor: rmh.paper["1-surface"].rest,
      };
    })();

    return {
      display: "flex",
      padding: theme.spacing(3),
      alignItems: "flex-start",
      gap: theme.spacing(2),
      alignSelf: "stretch",
      margin: 0,
      borderRadius: theme.shape.medium,
      borderStyle: "solid",
      borderWidth: theme.spacing(0.25),
      transition: theme.transitions.create(
        ["border-color", "background-color"],
        { duration: theme.transitions.duration.shortest }
      ),
      ...stateStyles,
    };
  };
